module.exports = __webpack_public_path__ + "img/context-aware.4c57487e.webp";